import { UserProfile, GENDER_TYPE } from "@/restapi/user";

export class UserModel {
  private user: UserProfile;

  constructor(userProfile: UserProfile) {
    const normalized = { ...userProfile } as UserProfile;
    const g = normalized.gender;

    if (g === undefined || g === null) {
      normalized.gender = GENDER_TYPE.NO_SELECTED;
    } else {
      let gv: number | null = null;

      if (typeof g === "string") {
        const parsed = Number(g);
        gv = Number.isFinite(parsed) ? parsed : null;
      } else if (typeof g === "number") {
        gv = g;
      }

      if (gv === null || gv === GENDER_TYPE.NO_SELECTED || gv === 0) {
        normalized.gender = GENDER_TYPE.NO_SELECTED;
      } else {
        const allowed: number[] = [
          GENDER_TYPE.NONBINARY,
          GENDER_TYPE.MALE,
          GENDER_TYPE.FEMALE,
        ];

        normalized.gender = allowed.includes(gv)
          ? gv
          : GENDER_TYPE.NONBINARY;
      }
    }

    this.user = normalized;
  }

  isEditCompleted(): boolean {
    return (
      this.user.birthday != null &&
      this.user.country != null &&
      this.user.pref != null &&
      this.user.gender != null
    );
  }
}